import { atom } from "recoil";

// KP全医療機関マスタのサイドバーにある投稿一覧用をもっと読み込むトリガー
export const postHasMoreState = atom({
  key: "postHasMoreState",
  default: true,
});